/* vito-bundle-tiers.js
   Zweck:   Gefuehrter Bundle-Konfigurator mit Slots. "Bezug hinzufuegen" -> Stoff -> Farbe.
            Groesse folgt automatisch dem Hauptprodukt. Stufen 10/15/20 % aus Settings.
   Basis:   Concept 6.0.0. Offizieller Vertrag: input[name="bundles"] in einem Element mit
            form="<product_form_id>". Concepts ProductForm.prepareFormData() macht daraus
            EINEN atomaren items[]-POST. Wir schreiben nur diese Inputs und senden das
            dokumentierte Event "bundle:change", damit <product-buy-price> mitzieht.
   Deps:    assets/vito-bundle-tiers.css
   Regeln:  keine Vorbelegung. Kein Fetch. Kein Abfangen von Theme-Events.
*/

class VitoBundleTiers extends HTMLElement {
  connectedCallback() {
    this.formId = this.getAttribute('form') || '';
    this.maxSlots = parseInt(this.getAttribute('data-max-slots'), 10) || 3;
    this.matchSize = this.getAttribute('data-match-size') !== 'false';
    this.fallbackBase = parseInt(this.getAttribute('data-base-price'), 10) || 0;

    this.tiers = this.parse('data-tiers', [])
      .filter(function (t) { return t && t.qty > 0 && t.pct > 0; })
      .sort(function (a, b) { return a.qty - b.qty; });
    this.covers = this.parse('data-covers', []);
    this.i18n = this.parse('data-i18n', {});

    this.slotsEl = this.querySelector('[data-vito-slots]');
    this.summaryEl = this.querySelector('[data-vito-summary]');
    this.tiersEl = this.querySelector('[data-vito-tiers]');
    this.inputsEl = this.querySelector('[data-vito-inputs]');

    /* Zustand: ein Eintrag pro Slot, null = leer. Beim Laden alles leer. */
    this.slots = new Array(this.maxSlots).fill(null);
    this.openSlot = null;
    this.draftFabric = null;

    this.onClick = this.onClick.bind(this);
    this.onVariantChange = this.onVariantChange.bind(this);
    this.addEventListener('click', this.onClick);
    this.eventTarget = this.form || document;
    this.eventTarget.addEventListener('variant:change', this.onVariantChange);

    this.render();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    if (this.eventTarget) {
      this.eventTarget.removeEventListener('variant:change', this.onVariantChange);
    }
  }

  parse(attr, fallback) {
    try {
      var v = JSON.parse(this.getAttribute(attr) || '');
      return v == null ? fallback : v;
    } catch (e) { return fallback; }
  }

  get form() {
    return this.formId && document.forms[this.formId] ? document.forms[this.formId] : null;
  }

  /* ---------- Hauptprodukt ---------- */

  currentVariant() {
    if (this.selectedVariant) return this.selectedVariant;
    var info = this.closest('product-info') || document.querySelector('product-info');
    var node = info && info.querySelector('[data-selected-variant]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  basePrice() {
    var v = this.currentVariant();
    return v && typeof v.price === 'number' ? v.price : this.fallbackBase;
  }

  /* Die Groesse des Hauptprodukts. Genommen wird der Optionswert, der auch bei den
     Bezuegen als Variante existiert — so ist es unabhaengig von der Optionsreihenfolge. */
  currentSize() {
    var v = this.currentVariant();
    if (!v) return null;
    var candidates = [v.option1, v.option2, v.option3].filter(function (x) {
      return typeof x === 'string' && x.length;
    });
    var sizes = {};
    this.covers.forEach(function (c) {
      (c.variants || []).forEach(function (vr) { sizes[String(vr.size).trim()] = true; });
    });
    for (var i = 0; i < candidates.length; i++) {
      if (sizes[candidates[i].trim()]) return candidates[i].trim();
    }
    return null;
  }

  variantFor(cover, size) {
    var list = cover.variants || [];
    var hit = null;
    if (size) {
      hit = list.filter(function (v) { return String(v.size).trim() === size && v.available; })[0] || null;
    }
    if (!hit && !this.matchSize) {
      hit = list.filter(function (v) { return v.available; })[0] || null;
    }
    return hit;
  }

  /* ---------- Stoff / Farbe ---------- */

  /* Gruppiert wird ueber die Taxonomie-GID — exakt und sprachunabhaengig.
     Faellt sie aus, wird auf den aus dem Titel abgeleiteten Stoff zurueckgegriffen. */
  fabricKey(cover) {
    var m = cover.meta || {};
    var gid = String(m.matGid || '').trim();
    return gid || ('t:' + this.fabricLabel(cover));
  }

  /* Anzeige des Stoffs. Reihenfolge:
       1. Metaobjekt-Label der Taxonomie, falls Liquid es liefert
       2. Markenbegriff Teddy / Linen — beide stehen auf der Do-not-translate-Liste
       3. sprachneutrale Ableitung: das Stueck zwischen Gedankenstrich und Farbe,
          ohne "RePET". Faengt uebersetzte Stoffnamen ab (it: "lino") und liefert
          immer ein kurzes Label statt des ganzen Produkttitels.
     Der ganze Titel wird nie als Button-Text verwendet. */
  fabricLabel(cover) {
    var m = cover.meta || {};
    var raw = String(m.matLabel || '').trim();
    if (raw) return this.shortFabric(raw);
    return this.shortFabric(this.fabricFromTitle(String(cover.title || '')));
  }

  shortFabric(raw) {
    if (/teddy/i.test(raw)) return 'Teddy';
    if (/linen/i.test(raw)) return 'Linen';
    return raw;
  }

  /* "Cover Donut Hundebettbezug – RePET Linen in Anthrazit" -> "Linen"
     "Fodera per Letto per cani donut – RePET lino in antracite" -> "lino" */
  fabricFromTitle(title) {
    var tail = title.split(/[–—]/).pop();
    if (!tail || tail === title) tail = title;
    tail = tail.replace(/\b(?:in|en|em)\s+[^\-–,]+$/i, '');
    tail = tail.replace(/\brepet\b/i, '').replace(/\bnylon\b/i, '');
    tail = tail.replace(/\s+/g, ' ').trim();
    if (!tail) tail = title;
    /* Harte Obergrenze: ein Stoff-Button darf niemals einen ganzen Satz tragen. */
    return tail.length > 24 ? tail.slice(0, 22).trim() + '…' : tail;
  }

  colourOf(cover) {
    var m = cover.meta || {};
    var raw = String(m.colLabel || '').trim();
    if (raw) return raw;
    /* Rueckfallebene: der Teil hinter dem letzten Trennwort im Titel. */
    var t = String(cover.title || '');
    var hit = t.match(/(?:\bin|\ben|\bem)\s+([^\-–,]+)$/i);
    return hit ? hit[1].trim() : t;
  }

  fabrics() {
    var self = this;
    var out = [];
    var seen = {};
    this.covers.forEach(function (c) {
      var k = self.fabricKey(c);
      if (seen[k]) return;
      seen[k] = true;
      out.push({ key: k, label: self.fabricLabel(c) });
    });
    return out;
  }

  draftFabricLabel() {
    var hit = this.fabrics().filter(function (f) { return f.key === this.draftFabric; }, this);
    return hit.length ? hit[0].label : '';
  }

  coversByFabric(key) {
    var self = this;
    return this.covers.filter(function (c) { return self.fabricKey(c) === key; });
  }

  /* ---------- Interaktion ---------- */

  onClick(event) {
    var el = event.target.closest('[data-vito-action]');
    if (!el) return;
    event.preventDefault();
    var action = el.getAttribute('data-vito-action');
    var index = parseInt(el.getAttribute('data-vito-slot'), 10);

    if (action === 'open') { this.openSlot = index; this.draftFabric = null; }
    else if (action === 'cancel') { this.openSlot = null; this.draftFabric = null; }
    else if (action === 'fabric') { this.draftFabric = el.getAttribute('data-vito-value'); }
    else if (action === 'back') { this.draftFabric = null; }
    else if (action === 'pick') { this.fill(index, el.getAttribute('data-vito-value')); }
    else if (action === 'remove') { this.slots[index] = null; this.compact(); }
    else if (action === 'tier') { this.applyTier(parseInt(el.getAttribute('data-vito-value'), 10)); }
    else return;

    this.commit();
  }

  fill(index, coverId) {
    var cover = this.covers.filter(function (c) { return String(c.id) === String(coverId); })[0];
    if (!cover) return;
    var variant = this.variantFor(cover, this.currentSize());
    if (!variant) return;
    this.slots[index] = {
      coverId: cover.id,
      variantId: variant.id,
      price: variant.price,
      size: variant.size,
      fabric: this.fabricLabel(cover),
      colour: this.colourOf(cover),
      img: cover.img || ''
    };
    this.openSlot = null;
    this.draftFabric = null;
  }

  /* Luecken schliessen, damit die Slots immer von oben gefuellt sind */
  compact() {
    var filled = this.slots.filter(function (s) { return s; });
    this.slots = new Array(this.maxSlots).fill(null);
    for (var i = 0; i < filled.length; i++) this.slots[i] = filled[i];
  }

  /* Stufe anklicken: fuellt bis zur Zielzahl mit dem jeweils ersten passenden Bezug,
     leert bei erneutem Klick. Der Kunde sieht danach jeden einzelnen Slot und kann
     ihn tauschen oder entfernen. */
  applyTier(qty) {
    var current = this.filledCount();
    if (current === qty) qty = 0;
    if (qty < current) {
      for (var i = qty; i < this.maxSlots; i++) this.slots[i] = null;
    } else {
      var size = this.currentSize();
      var self = this;
      for (var j = current; j < qty && j < this.maxSlots; j++) {
        var pick = this.covers.filter(function (c) { return !!self.variantFor(c, size); })[0];
        if (!pick) break;
        this.fill(j, pick.id);
      }
    }
    this.openSlot = null;
    this.draftFabric = null;
  }

  onVariantChange(event) {
    this.selectedVariant = (event.detail && event.detail.variant) || null;
    /* Groesse hat sich geaendert: gewaehlte Bezuege auf die neue Groesse umstellen.
       Es wird nichts hinzugefuegt und nichts entfernt, nur die Groesse nachgezogen. */
    var size = this.currentSize();
    var self = this;
    this.slots = this.slots.map(function (s) {
      if (!s) return null;
      var cover = self.covers.filter(function (c) { return String(c.id) === String(s.coverId); })[0];
      if (!cover) return null;
      var v = self.variantFor(cover, size);
      if (!v) return null;
      s.variantId = v.id; s.price = v.price; s.size = v.size;
      return s;
    });
    this.compact();
    this.commit();
  }

  filledCount() {
    return this.slots.filter(function (s) { return s; }).length;
  }

  /* ---------- Concept-Anbindung ---------- */

  commit() {
    this.syncInputs();
    this.render();
    this.notify();
  }

  syncInputs() {
    if (!this.inputsEl) return;
    var html = '';
    this.slots.forEach(function (s, i) {
      if (!s) return;
      html += '<input type="checkbox" name="bundles" checked'
        + ' value="' + s.variantId + '" data-min="1" data-price="' + s.price + '"'
        + ' id="VitoBundle-' + i + '-' + s.variantId + '" tabindex="-1" aria-hidden="true">';
    });
    this.inputsEl.innerHTML = html;
  }

  /* Concepts dokumentiertes Event — <product-buy-price> haengt daran. */
  notify() {
    var items = this.slots.filter(function (s) { return s; }).map(function (s) {
      return { id: String(s.variantId), quantity: '1', price: String(s.price) };
    });
    (this.form || document).dispatchEvent(new CustomEvent('bundle:change', {
      detail: { items: items }
    }));
  }

  /* ---------- Rechnen ---------- */

  /* Shopify rabattiert pro Warenkorb-Position und schneidet Cent ab. Gleiche Varianten
     werden vorher zu EINER Position zusammengefasst. Genau so wird hier gerechnet. */
  addonLines() {
    var lines = {};
    this.slots.forEach(function (s) {
      if (!s) return;
      lines[s.variantId] = (lines[s.variantId] || 0) + s.price;
    });
    return Object.keys(lines).map(function (k) { return lines[k]; });
  }

  tierFor(count) {
    var hit = null;
    for (var i = 0; i < this.tiers.length; i++) if (count >= this.tiers[i].qty) hit = this.tiers[i];
    return hit;
  }

  nextTier(count) {
    for (var i = 0; i < this.tiers.length; i++) if (this.tiers[i].qty > count) return this.tiers[i];
    return null;
  }

  money(cents) {
    if (window.theme && theme.Currency && theme.settings) {
      var fmt = theme.settings.currencyCodeEnabled
        ? theme.settings.moneyWithCurrencyFormat
        : theme.settings.moneyFormat;
      return theme.Currency.formatMoney(cents, fmt);
    }
    return (cents / 100).toFixed(2);
  }

  t(key, rep) {
    var raw = this.i18n[key];
    if (raw == null) return '';
    if (typeof raw === 'object') {
      var n = rep && typeof rep.count === 'number' ? rep.count : 0;
      raw = n === 1 ? (raw.one || raw.other || '') : (raw.other || raw.one || '');
    }
    if (rep) {
      Object.keys(rep).forEach(function (k) {
        raw = raw.split('{{ ' + k + ' }}').join(rep[k]).split('{{' + k + '}}').join(rep[k]);
      });
    }
    return raw;
  }

  esc(v) {
    return String(v == null ? '' : v)
      .split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;').split('"').join('&quot;');
  }

  /* ---------- Ausgabe ---------- */

  render() {
    this.renderTiers();
    this.renderSlots();
    this.renderSummary();
  }

  renderTiers() {
    if (!this.tiersEl) return;
    var count = this.filledCount();
    var active = this.tierFor(count);
    var self = this;
    this.tiersEl.innerHTML = this.tiers.map(function (t) {
      var on = !!active && active.qty === t.qty;
      /* Kein role="listitem" — das ueberschreibt die Button-Semantik.
         Der Container traegt role="group", die Buttons bleiben Buttons. */
      return '<button type="button" class="vito-bt__tier"'
        + ' data-vito-action="tier" data-vito-value="' + t.qty + '"'
        + ' aria-pressed="' + (on ? 'true' : 'false') + '">'
        + '<span class="vito-bt__tier-pct">' + t.pct + '&nbsp;%</span>'
        + '<span class="vito-bt__tier-qty">'
        + self.esc(self.t('tier_qty', { count: t.qty }))
        + '</span></button>';
    }).join('');
  }

  renderSlots() {
    if (!this.slotsEl) return;
    var self = this;
    var size = this.currentSize();
    var html = '';

    for (var i = 0; i < this.maxSlots; i++) {
      var s = this.slots[i];
      var locked = !s && i > 0 && !this.slots[i - 1];
      var isOpen = this.openSlot === i;

      html += '<div class="vito-bt__slot' + (s ? ' is-filled' : '')
        + (locked ? ' is-locked' : '') + (isOpen ? ' is-open' : '') + '">';
      html += '<span class="vito-bt__slot-num" aria-hidden="true">' + (i + 1) + '</span>';
      html += '<div class="vito-bt__slot-main">';

      if (s) {
        html += '<strong class="vito-bt__slot-name">' + this.esc(s.fabric + ' · ' + s.colour) + '</strong>'
          + '<small class="vito-bt__slot-meta">' + this.esc(this.t('size')) + ' ' + this.esc(s.size)
          + ' · ' + this.money(s.price) + '</small>';
      } else if (locked) {
        html += '<span class="vito-bt__slot-locked">' + this.esc(this.t('locked')) + '</span>';
      } else if (!isOpen) {
        html += '<button type="button" class="vito-bt__add" data-vito-action="open" data-vito-slot="' + i + '">'
          + '<span aria-hidden="true">+</span> ' + this.esc(this.t('add_cover')) + '</button>';
      } else {
        html += this.renderChooser(i, size);
      }

      html += '</div>';

      if (s) {
        html += '<button type="button" class="vito-bt__slot-action" data-vito-action="remove"'
          + ' data-vito-slot="' + i + '">' + this.esc(this.t('remove')) + '</button>';
      } else if (isOpen) {
        html += '<button type="button" class="vito-bt__slot-action" data-vito-action="cancel"'
          + ' data-vito-slot="' + i + '">' + this.esc(this.t('cancel')) + '</button>';
      }

      html += '</div>';
    }

    this.slotsEl.innerHTML = html;
  }

  renderChooser(index, size) {
    var self = this;
    var html = '<div class="vito-bt__chooser">';

    if (!this.draftFabric) {
      html += '<p class="vito-bt__chooser-label">' + this.esc(this.t('choose_fabric')) + '</p>';
      html += '<div class="vito-bt__opts">';
      this.fabrics().forEach(function (f) {
        html += '<button type="button" class="vito-bt__opt" data-vito-action="fabric"'
          + ' data-vito-slot="' + index + '" data-vito-value="' + self.esc(f.key) + '">'
          + self.esc(f.label) + '</button>';
      });
      html += '</div>';
    } else {
      html += '<p class="vito-bt__chooser-label">'
        + '<button type="button" class="vito-bt__back" data-vito-action="back" data-vito-slot="' + index + '">'
        + '<span aria-hidden="true">‹</span> ' + this.esc(this.t('back')) + '</button>'
        + '<span>' + this.esc(this.t('choose_colour')) + ' — ' + this.esc(this.draftFabricLabel()) + '</span></p>';
      html += '<div class="vito-bt__opts vito-bt__opts--colour">';
      this.coversByFabric(this.draftFabric).forEach(function (c) {
        var v = self.variantFor(c, size);
        var out = !v;
        html += '<button type="button" class="vito-bt__opt vito-bt__opt--colour'
          + (out ? ' is-out' : '') + '" data-vito-action="pick"'
          + ' data-vito-slot="' + index + '" data-vito-value="' + c.id + '"'
          + (out ? ' disabled' : '') + '>'
          + (c.img ? '<img src="' + self.esc(c.img) + '" alt="" width="40" height="40" loading="lazy">' : '')
          + '<span>' + self.esc(self.colourOf(c)) + '</span>'
          + (out ? '<small>' + self.esc(self.t('sold_out')) + '</small>' : '')
          + '</button>';
      });
      html += '</div>';
    }

    html += '</div>';
    return html;
  }

  renderSummary() {
    if (!this.summaryEl) return;

    var count = this.filledCount();
    var tier = this.tierFor(count);
    var lines = this.addonLines();
    var addonTotal = lines.reduce(function (a, b) { return a + b; }, 0);
    var base = this.basePrice();
    var pct = tier ? tier.pct : 0;

    var discount = 0;
    if (pct > 0) {
      discount = [base].concat(lines).reduce(function (sum, amount) {
        return sum + Math.floor(amount * pct / 100);
      }, 0);
    }

    var rows = [this.row(this.t('base'), this.money(base))];
    if (count > 0) rows.push(this.row(this.t('addons', { count: count }), this.money(addonTotal)));
    if (discount > 0) rows.push(this.row(this.t('discount', { percent: pct }), '−' + this.money(discount), 'vito-bt__row--discount'));
    rows.push(this.row(this.t('subtotal'), this.money(base + addonTotal - discount), 'vito-bt__row--total'));

    var html = '<dl class="vito-bt__list">' + rows.join('') + '</dl>';
    if (discount > 0 && this.t('discount_note')) {
      html += '<p class="vito-bt__note">' + this.esc(this.t('discount_note')) + '</p>';
    }
    var next = this.nextTier(count);
    if (next) {
      html += '<p class="vito-bt__hint">' + this.esc(this.t('next_tier', {
        count: next.qty - count, percent: next.pct
      })) + '</p>';
    }
    if (this.matchSize && this.t('size_note')) {
      html += '<p class="vito-bt__note">' + this.esc(this.t('size_note')) + '</p>';
    }
    this.summaryEl.innerHTML = html;
  }

  row(label, value, cls) {
    return '<div class="vito-bt__row' + (cls ? ' ' + cls : '') + '">'
      + '<dt>' + this.esc(label) + '</dt><dd>' + value + '</dd></div>';
  }
}

if (!customElements.get('vito-bundle-tiers')) {
  customElements.define('vito-bundle-tiers', VitoBundleTiers);
}
